module.exports = __webpack_public_path__ + "static/media/Img_card_1031.8a04fc6b.jpg";